import EntityService from "./entity";

class OrganizationService extends EntityService {
  constructor(name) {
    super(name)
  }
}

export default new OrganizationService("organization")



// WEBPACK FOOTER //
// ./src/services/organization.js